module.exports = __webpack_public_path__ + "img/daikuan.8947e289.png";